export const CRAMER_CLASSE_SELECTED = 'substanceForm/CRAMER_CLASSE_SELECTED';
